import { render } from "./AlsoAsk.vue?vue&type=template&id=f29516c8"
import script from "./AlsoAsk.vue?vue&type=script&lang=js"
export * from "./AlsoAsk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__